import { render } from "./MWSponserSlide.vue?vue&type=template&id=7510a4e8"
import script from "./MWSponserSlide.vue?vue&type=script&lang=js"
export * from "./MWSponserSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__